// Lets app boot fall back to the last-known profile/permissions when there's
// no network to fetch them fresh — otherwise the app hangs on the loading
// spinner forever if a staff iPad opens with zero connectivity.

const PROFILE_PREFIX = 'hi_portal_cached_profile_';
const LAST_USER_ID_KEY = 'hi_portal_last_user_id';

export const saveCachedProfile = (userId, profile, permissions) => {
  try {
    localStorage.setItem(PROFILE_PREFIX + userId, JSON.stringify({ profile, permissions, savedAt: Date.now() }));
    localStorage.setItem(LAST_USER_ID_KEY, userId);
  } catch (_) {
    // localStorage full or unavailable (e.g. private browsing) — non-fatal, just no offline fallback.
  }
};

export const getCachedProfile = (userId) => {
  try {
    const raw = localStorage.getItem(PROFILE_PREFIX + userId);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const getLastKnownUserId = () => {
  try {
    return localStorage.getItem(LAST_USER_ID_KEY);
  } catch (_) {
    return null;
  }
};

export const withTimeout = (promise, ms = 7000) => Promise.race([
  promise,
  new Promise((_, reject) => setTimeout(() => reject(new Error('offline-timeout')), ms)),
]);
